import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var Clearfix = function Clearfix(props) {
  return ___EmotionJSX("div", _extends({
    className: "clear"
  }, props.uiEvents));
};